import { render } from "./staticimage.vue?vue&type=template&id=2cc46ede&scoped=true"
import script from "./staticimage.vue?vue&type=script&lang=js"
export * from "./staticimage.vue?vue&type=script&lang=js"

import "./staticimage.vue?vue&type=style&index=0&id=2cc46ede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc46ede"]])

export default __exports__